import { useState } from "react";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";

import { clearUserData, setUser } from "../redux/UserSlice";
import axios from "axios";
import { api } from "../services/helpers";
import { resolveRole } from "../services/roles";

interface IAuthProps {
  email: string;
  password: string;
  tokenFromFlashDrive: string;
}

const useAuthenthication = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const signInCall = async ({
    email,
    password,
    tokenFromFlashDrive,
  }: IAuthProps) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${api}/authentication/login`, {
        username: email,
        password,
        tokenFromFlashDrive,
      });

      const { access_token, user } = response.data;
      let role = user?.role;
      let username = user?.username || email;
      let id = user?.id;

      if (access_token && !role) {
        try {
          const decoded: any = jwtDecode(access_token);
          role = decoded.role;
          username = decoded.username || username;
          id = decoded.sub || id;
        } catch {
          /* ignore */
        }
      }

      dispatch(
        setUser({
          user: {
            email: username,
            username,
            id,
            role: resolveRole(role),
          },
          accessToken: access_token,
        })
      );
    } catch (error: any) {
      const data = error?.response?.data;
      const payload = {
        code: data?.code || data?.message?.code,
        message:
          data?.message?.message ||
          data?.message ||
          error?.message ||
          "Login failed",
      };
      throw payload;
    } finally {
      setIsLoading(false);
    }
  };

  const logoutCall = () => {
    dispatch(clearUserData());
  };

  return { isLoading, signInCall, logoutCall };
};

export default useAuthenthication;
